export const apiUpdate = (): string => '/users/profile/'
export const apiUpdateAvatar = (): string => '/users/avatar'
